import './TextureUnity.less';
import { Unity, useUnityContext } from 'react-unity-webgl';
import { useEffect, useState } from 'react';
import Thumbnail from '@/assets/Thumbnail.png';
import { useOrientation } from '@/utils/orientation';

export default function Home() {
  const [loading, setLoading] = useState(false);
  const [progression, setProgression] = useState(0);
  const orientation = useOrientation();

  const { unityProvider, isLoaded, loadingProgression } = useUnityContext({
    loaderUrl: `/html/Build/html.loader.js`,
    dataUrl: `/html/Build/html.data.unityweb`,
    frameworkUrl: `/html/Build/html.framework.js.unityweb`,
    codeUrl: `/html/Build/html.wasm.unityweb`,
    workerUrl: `/html/Build/html.data.unityweb`,
    streamingAssetsUrl: '/html/StreamingAssets',
    companyName: 'MRStage',
    productName: 'AITexturePainter',
    productVersion: 'v0.1-20250411-r4',
  });
  useEffect(() => {
    setProgression((loadingProgression * 100).toFixed());
  }, [loadingProgression]);
  useEffect(() => {
    setLoading(isLoaded);
  }, [isLoaded]);

  return (
    <div className="texture-unity">
      <div className="content">
        {!loading && (
          <div className="loadingState">
            <img src={Thumbnail} />
            <div className="progress">
              <div className="progressItem" style={{ width: `${progression}%` }} />
              <div className="label">{progression}%</div>
            </div>
          </div>
        )}
        <Unity
          // key={'unity_' + orientation}
          unityProvider={unityProvider}
          style={{ width: '100%', height: '100%' }}
        />
      </div>
    </div>
  );
}
